import React from 'react'
import Text from '../sections/text.js'
import offsetStyle from "../components/css/offsetContentStyle.module.scss"

export default function({title, coverImage, children, noquote}){
    return (
        <article className={offsetStyle.content}>
            <header>
                <h1>{title}</h1>
                <img src={"/assets/"+coverImage} />
            </header>

            <div className={offsetStyle.message}>
                
                { !noquote && <Text theme="dark"><div style={{paddingLeft: "20px", paddingTop: "100px"}}><span>"</span>{children}</div></Text>}
                { noquote && <Text theme="dark"><div style={{paddingLeft: "20px", paddingTop: "30px"}}>{children}</div></Text>}
                
            </div>

        </article>
    )
}